import api from './APIService';

class PaymentService {
	registerEvent() {
		return api.fetch({ method: 'get', path: '/participant/register/event/' });
	}
	getQueue(registrantId){
		return api.fetch({ method: 'get', path: '/queue/payment/event/'+registrantId });
	}
	getQueueTimer(queueId){
		return api.fetch({ method: 'get', path: '/queue/timer/'+queueId })
	}
	getQueuePayment(){
		return api.fetch({ method: 'get', path: '/queue/payment' });
	}
	getEventRegPayment(registrantId){
		return api.fetch({ method: 'get', path: '/livelaps/eventRegistrationPayment/'+registrantId });
	}
	registerEventSummary(eventId, userId, buddies = false) {
		if(buddies)
			return api.fetch({ method: 'get', path: '/participant/register/event/summary/'+eventId+'/'+userId+'/'+buddies });
		
		return api.fetch({ method: 'get', path: '/participant/register/event/summary/'+eventId+'/'+userId });
	}
	registerEventPending(eventId, userId) {
		return api.fetch({ method: 'get', path: '/participant/register/event/pending/'+eventId+'/'+userId });
	}
	unpaid(userId) {
		return api.fetch({ method: 'get', path: '/participant/register/event/unpaid/'+userId });
	}
	getPrice(eventId) {
		return api.fetch({ method: 'get', path: '/participant/register/event/getEventPrices/'+eventId });
	}
	setBuddies(data) {
		return api.fetch({ method: 'post', path: '/participant/register/event/buddies', data });
	}
	hasUnpaidRegistrations() {
		return api.fetch({ method: 'get', path: '/participant/register/event/hasUnpaidRegistrations'});
	}
	validateCouponRegister(code, registrantId) {
		return api.fetch({ method: 'get', path: '/participant/register/coupon/validate/' + code + '/' + registrantId });
	}
}

export default new PaymentService();
